module.exports = __webpack_public_path__ + "img/1-3.f477c68d.svg";